import { Component } from '@angular/core';
import { RouterOutlet, RouterLink, RouterLinkActive } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterOutlet],
    template: `
        <router-outlet></router-outlet>
    `,
    styles: [`
        .dev-nav { background: #333; color: white; padding: 10px; display: flex; gap: 15px; font-size: 14px; position: sticky; top: 0; z-index: 1000; }
        .dev-nav a { color: #aaa; text-decoration: none; }
        .dev-nav a.active { color: #00d1b2; font-weight: bold; }
        .role-tag { color: #888; text-transform: uppercase; font-size: 10px; align-self: center; }
    `]
})
export class AppComponent {
    title = 'Eliquis PAP';

    constructor(private translate: TranslateService) {
        this.translate.setDefaultLang('en');
        this.translate.use('en');
    }
}
